/**
 * Utility Service for common UI-related calculations
 */

/**
 * Calculates percentage for progress bars, ensuring it stays between 0 and 100
 */
export const calculatePercentage = (current, limit, isUnlimited = false) => {
    if (isUnlimited || limit <= 0) return 0;
    return Math.min(Math.round((current / limit) * 100), 100);
};

/**
 * Formats a date string into a localized short date (DD/MM/YYYY)
 */
export const formatDateShort = (dateString, locale = 'es-ES') => {
    if (!dateString) return null;
    return new Date(dateString).toLocaleDateString(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

/**
 * Calculates net value after applying retentions
 */
export const calculateNetValue = (gross, retention = 0) => {
    return Number(gross || 0) - Number(retention || 0);
};

/**
 * Formats a decimal (0.19) as a percentage string (19.0%)
 */
export const formatPercent = (value, decimals = 1) => {
    if (value === undefined || value === null) return "0%";
    return `${(Number(value) * 100).toFixed(decimals)}%`;
};

/**
 * Calculates the total paid amount from initial and current balance
 */
export const calculateTotalPaid = (initial, current) => {
    return Number(initial || 0) - Number(current || 0);
};
